var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1047448_gmail_google_inbox_mail_icon 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8056 10.9859C13.6885 10.8654 13.4988 10.8654 13.3817 10.9859L11.5634 12.8573C11.5072 12.9152 11.4756 12.9936 11.4756 13.0756C11.4756 13.1575 11.5072 13.2359 11.5634 13.2938L16.8906 18.7773C16.9492 18.8376 17.0259 18.8677 17.1026 18.8677C17.1793 18.8677 17.256 18.8376 17.3145 18.7773L27.9612 7.81746C28.0783 7.69691 28.0783 7.5016 27.9612 7.38104L26.1433 5.50932C26.087 5.45142 26.0109 5.41888 25.9313 5.41888C25.8516 5.41888 25.7754 5.45148 25.7192 5.50932L17.1025 14.3797L13.8056 10.9859Z",
    fill: "#163E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.84 14.6302L31.8396 14.6296C31.6868 14.1565 31.4076 13.7587 31.0313 13.4792L26.5456 10.1473L25.6866 11.0316L30.2748 14.4396L30.3295 14.4801C30.3781 14.5163 30.415 14.5673 30.4565 14.6127C30.4665 14.6236 30.4775 14.6331 30.487 14.6445C30.5294 14.7778 30.485 14.9271 30.3637 15.0031L3.39355 31.9073C3.66711 32.0294 3.96778 32.0986 4.28439 32.0986H29.7156C30.9556 32.0986 31.9645 31.0603 31.9645 29.7838V15.3564C31.9645 15.1276 31.9238 14.8901 31.84 14.6302Z",
    fill: "#163E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.54389 14.6126C3.58526 14.5674 3.62208 14.5165 3.67047 14.4804L16.386 5.0355C16.7538 4.76242 17.2468 4.76242 17.6145 5.0355L22.0972 8.36513L22.9562 7.48081L18.3161 4.03421C17.5291 3.44945 16.4715 3.44945 15.6845 4.03421L2.96864 13.4795C2.59345 13.7585 2.31401 14.1558 2.1608 14.629L2.16026 14.6299C2.07679 14.8891 2.03613 15.1266 2.03613 15.3563V29.7838C2.03613 30.4877 2.34933 31.1114 2.83234 31.5362L16.6886 22.8514L3.54389 14.6126Z",
    fill: "#163E6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingGmail);
export default __webpack_public_path__ + "static/media/landing_gmail.2708d6c8bb45b8a31a62bffbd4d07845.svg";
export { ForwardRef as ReactComponent };